import { Component, OnInit } from '@angular/core';
import { EtdService } from '../../../services/etd.service';
import { FaqModel } from '../../../models/faq.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-faq-section',
  templateUrl: './faq-section.component.html',
  styleUrls: ['./faq-section.component.scss'],
})
export class FaqSectionComponent implements OnInit {
  faqs: FaqModel[] = [];
  newFaqSectionVisible = false;
  isEditing = false;
  selectedFaq: FaqModel = new FaqModel();

  constructor(
    private _etdService: EtdService,
    private toastr: ToastrService,
  ) {
  }

  ngOnInit() {
    this.getAllFaqs();
  }

  toggleNewFaqSection() {
    if (this.newFaqSectionVisible) {
      this.selectedFaq = new FaqModel();
    }
    this.newFaqSectionVisible = !this.newFaqSectionVisible;
  }

  onFaqSubmitEvent(state) {
    if (state) {
      if (this.isEditing) {
        this.successUpdateMessage();
        this.getAllFaqs();
        this.toggleNewFaqSection();
        this.isEditing = false;
      } else {
        this.successCreateMessage();
        this.getAllFaqs();
        this.toggleNewFaqSection();
      }
    } else {
      if (this.isEditing) {
        this.errorUpdateMessage();
        this.isEditing = false;
      } else {
        this.errorCreateMessage();
      }
    }
  }

  getAllFaqs() {
    this._etdService
      .getAllFaqs()
      .subscribe(faqs => this.faqs = faqs);
  }

  onEditFaq(faq: FaqModel) {
    this.selectedFaq = faq;
    this.toggleNewFaqSection();
    this.isEditing = true;
  }

  onDeleteFaq(id) {
    this._etdService
      .deleteFaq(id)
      .subscribe(() => {
        this.getAllFaqs();
        this.successDeleteMessage();
      }, () => {
        this.errorDeleteMessage();
      });
  }

  /* ##### Alert messages ##### */
  successCreateMessage() {
    this.toastr.success('Pridanie novej položky do FAQ prebehlo úspešne.', 'FAQ vytvorený');
  }

  errorCreateMessage() {
    this.toastr.error('Vyskytla sa chyba počas vytvárania nového FAQ.', 'Chyba');
  }

  successDeleteMessage() {
    this.toastr.success('Zmazanie položky prebehlo úspešne.', 'FAQ zmazaný');
  }

  errorDeleteMessage() {
    this.toastr.error('Vyskytla sa chyba počas mazania FAQ.', 'Chyba');
  }

  successUpdateMessage() {
    this.toastr.success('Upravenie položky prebehlo úspešne.', 'FAQ upravený');
  }

  errorUpdateMessage() {
    this.toastr.error('Vyskytla sa chyba počas upravovania FAQ.', 'Chyba');
  }

}
